import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import DownlineTable from "./table/downlineTable";

const MyDownlinePage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="downline_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="My Downline"
      countContainer="Total Downline : 0"
      table={<DownlineTable />}
    />
  );
};

export default MyDownlinePage;
